/**
 * The deployment's identity, in one place. This fork runs as 台灣法律科技平台; the upstream
 * project it is built on is credited in `UPSTREAM` (MIT requires the notice, see /m/licenses).
 */
export const BRAND = {
    name: {"zh-TW": "台灣法律科技平台", en: "Taiwan Legal Tech Platform"},
    shortName: "法律科技",
    /** Set under the wordmark, as on the legaltech.org.tw share card. */
    caption: "TAIWAN LEGAL TECH PLATFORM",
    homeUrl: "https://legaltech.org.tw/",
    colors: {accent: "#d8f06d", ink: "#0c1f1b", paper: "#f4f2ec"},
} as const

export const UPSTREAM = {
    name: "Agenta",
    copyright:
        "Copyright (c) 2023–2025 Agentatech UG (haftungsbeschränkt), doing business as “Agenta”",
    repository: "https://github.com/Agenta-AI/agenta",
    license: "MIT",
} as const
